import { projectTypeIcons as icons, menuIcons } from 'img/icons'

const names = {
	TRACKER: "tracker",
	AGRISMART: "agrismart",
	ALARM: "alarm",
	SWITCH: "switch",
	BADGE: "badge",
	AGRISMART2: "agrismart2",
	METEOSMART: "meteosmart",
	SOLARSMART: "solarsmart",
	RADARPEST: "radarpest",
	AGRIVOLTAICO: "agrivoltaico",
	TRAPSCORE: "trapscore",
};

const types = [
	{
		id:1,
		name: names.TRACKER,
		description: "Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizioneBreve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve descrizione Breve",
		link: "https://www.waiv.it/tracker",
		icon: icons.tracker,
		iconHover: icons.tracker_over,
		smallIcon: icons.tracker_small,
		smallIconHover: icons.tracker_smallOver,
	},
	{
		id:2,
		name: names.AGRISMART,
		description: "",
		link: "http://www.agrismartiot.it/",
		icon: icons.agrismart,
		iconHover: icons.agrismart_over,
		smallIcon: icons.agrismart_small,
		smallIconHover: icons.agrismart_smallOver,
		video: require("../img/videos/agrismart.mp4"),
	},
	{
		id: 4,
		name: names.SWITCH,
		description: "",
		link: "https://www.waiv.it/tracker",
		icon: icons.switch,
		iconHover: icons.switch_over,
		smallIcon: icons.switch_small,
		smallIconHover: icons.switch_smallOver,
	},
	{
		id:5,
		name: names.ALARM,
		description: "",
		link: "https://www.waiv.it/tracker",
		icon: icons.tracker,
		iconHover: icons.tracker_over,
		smallIcon: icons.tracker_small,
		smallIconHover: icons.tracker_smallOver,
		hidden: true,
	},
	{
		id: 6,
		name: names.BADGE,
		description: "",
		link: "https://www.waiv.it/badge",
		icon: icons.badge,
		iconHover: icons.badge_over,
		smallIcon: icons.badge_small,
		smallIconHover: icons.badge_smallOver,
	},
	{
		id:7,
		name: names.AGRISMART2,
		description: "",
		link: "http://www.agrismartiot.it/",
		icon: icons.agrismart,
		iconHover: icons.agrismart_over,
		smallIcon: icons.agrismart_small,
		smallIconHover: icons.agrismart_smallOver,
		video: require("../img/videos/agrismart.mp4"),
	},
	{
		id:8,
		name: names.METEOSMART,
		description: "",
		link: "http://www.agrismartiot.it/",
		icon: icons.agrismart,
		iconHover: icons.agrismart_over,
		smallIcon: icons.agrismart_small,
		smallIconHover: icons.agrismart_smallOver,
		hidden: true,
	},
	{
		id:9,
		name: names.SOLARSMART,
		description: "",
		link: "http://www.agrismartiot.it/",
		icon: icons.agrismart,
		iconHover: icons.agrismart_over,
		smallIcon: icons.agrismart_small,
		smallIconHover: icons.agrismart_smallOver,
	},
	{
		id: 10,
		name: names.RADARPEST,
		description: "",
		link: "http://www.agrismartiot.it/",
		icon: menuIcons.phyto,
		iconHover: menuIcons.phyto_over,
		smallIcon: menuIcons.phyto,
		smallIconHover: menuIcons.phyto_over,
		hidden: true,
	},
	{
		id: 11,
		name: names.AGRIVOLTAICO,
		description: "",
		link: "http://www.agrismartiot.it/",
		icon: icons.agrismart,
		iconHover: icons.agrismart_over,
		smallIcon: icons.agrismart_small,
		smallIconHover: icons.agrismart_smallOver,
	},
	{
		id: 12,
		name: names.TRAPSCORE,
		description: "",
		link: "http://www.agrismartiot.it/",
		icon: menuIcons.phyto,
		iconHover: menuIcons.phyto_over,
		smallIcon: menuIcons.phyto,
		smallIconHover: menuIcons.phyto_over,
	},
];

export function findProjectTypeByName(projectTypeName) {
	return types.find(t => t.name === projectTypeName)
}

const unknownType = {
	name: "UNKNOWN",
	description: "",
	link: "",
	icon: icons.unknown,
	iconHover: icons.unknown_over,
	smallIcon: icons.unknown_small,
	smallIconHover: icons.unknown_smallOver,
}

export default {types, names, unknownType}
